// extracted by mini-css-extract-plugin
export default {"loader":"odKWN7NN"};